import React from 'react';
import PropTypes from 'prop-types';

import {Field, reduxForm} from 'redux-form';
import Button from '../button/Button';
import FieldText from '../fields/fieldText/FieldText';
import FieldCheckbox from '../fields/fieldCheckbox/FieldCheckbox';
import {FormattedMessage, injectIntl} from 'react-intl';

@injectIntl
@reduxForm({
  form: 'oAuthEmail',
  validate: ({tosAccepted}) => ({
    tosAccepted: tosAccepted ? undefined : <FormattedMessage id="section.auth.accept-tos"/>
  })
})
export default class OAuthEmailForm extends React.PureComponent {
  render() {
    const {intl, handleSubmit, submitting, error} = this.props;

    return (
      <form className="form" onSubmit={handleSubmit}>
        {error && <span className="form__error">{error}</span>}

        <Field
          name="email"
          type="email"
          placeholder={intl.formatMessage({id: 'section.generic.email'})}
          component={FieldText}
          className="field-text--modal"
        />

        <Button full filled loading={submitting} disabled={submitting}>
          <FormattedMessage id="section.generic.confirm"/>
        </Button>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./components/auth/OAuthEmailForm.js